import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Events } from './components/Events';
import { Spaces } from './components/Spaces';
import { Branches } from './components/Branches';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  useEffect(() => {
    const ogTags = [{
      property: 'og:title',
      content: 'El Matambrito – Parrilla y shows en Villa Gobernador Gálvez'
    }, {
      property: 'og:description',
      content: 'Parrilla, patio, comida casera, shows en vivo y momentos únicos para compartir.'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/kgDhcY2AxDGiGsF736dPbt/WhatsApp_Image_2026-04-14_at_16.23.43.jpg'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:url',
      content: 'https://elmatambrito.com'
    }, {
      property: 'og:site_name',
      content: 'El Matambrito'
    }];
    const twitterTags = [{
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:title',
      content: 'El Matambrito – Parrilla y shows en Villa Gobernador Gálvez'
    }, {
      name: 'twitter:description',
      content: 'Parrilla, patio, comida casera, shows en vivo y momentos únicos para compartir.'
    }, {
      name: 'twitter:image',
      content: 'https://cdn.magicpatterns.com/uploads/kgDhcY2AxDGiGsF736dPbt/WhatsApp_Image_2026-04-14_at_16.23.43.jpg'
    }];
    document.title = 'El Matambrito – Parrilla y shows en Villa Gobernador Gálvez';
    // Set description meta
    let descMeta = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!descMeta) {
      descMeta = document.createElement('meta');
      descMeta.name = 'description';
      document.head.appendChild(descMeta);
    }
    descMeta.content = 'Parrilla, patio, comida casera, shows en vivo y momentos únicos para compartir.';
    const createdElements: HTMLMetaElement[] = [];
    ogTags.forEach(({
      property,
      content
    }) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
        createdElements.push(meta);
      }
      meta.content = content;
    });
    twitterTags.forEach(({
      name,
      content
    }) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
        createdElements.push(meta);
      }
      meta.content = content;
    });
    return () => {
      createdElements.forEach(el => el.remove());
    };
  }, []);
  return <div className="min-h-screen bg-matambrito-black selection:bg-matambrito-red-fire selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Services data-id="element-5" />
        <Events data-id="element-6" />
        <Spaces data-id="element-7" />
        <Branches data-id="element-8" />
        <Gallery data-id="element-9" />
        <Reviews data-id="element-10" />
        <Contact data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <WhatsAppButton data-id="element-13" />
    </div>;
}